import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { pickFunction } from 'Helpers/Affordances';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const Layout = ({ className, classes }) => {
  const { onSubmit, saving } = useMetaLayoutContext();
  const { loadModalCollectionByLink, modalCollection } = useModalContext();
  const resource = modalCollection.resources().head();
  const maybeHandlePrevious = pickFunction(resource, {
    [fr.relationships.previousLink.name]: () => () => {
      const previousLink = resource
        .relationship(fr.relationships.previousLink.name)
        .link('related');

      loadModalCollectionByLink(previousLink.url());
    },
    [fr.relationships.default.name]: () => undefined,
  });

  const isOneTime = resource.attr('isOneTimeWithdraw') === 'true';

  return (
    <Box className={classNames(classes.root, className)}>
      <TitleSection />

      <MetaField attr="description" />
      <MetaField attr="virtualAccount" />
      <MetaField attr="isQualifiedWithdraw" />
      <MetaField attr="withdrawValue" />

      <MetaField attr="startType" />
      {resource.attr('startType') === 'date' && (
        <MetaField attr={'startDate'} />
      )}
      {resource.attr('startType').includes('age') && (
        <MetaField attr={'startAtAge'} />
      )}

      <MetaField attr="recurringIntervalCount" disabled={saving || isOneTime} />
      <MetaField attr="isOneTimeWithdraw" />

      <MetaField attr="endType" disabled={saving || isOneTime} />
      {resource.attr('endType') === 'date' && (
        <MetaField attr={'endDate'} disabled={saving || isOneTime} />
      )}
      {resource.attr('endType').includes('age') && (
        <MetaField attr={'endAtAge'} disabled={saving || isOneTime} />
      )}

      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={maybeHandlePrevious}
      />
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
